module.exports = __webpack_public_path__ + "img/样例3.77cfb3f3.png";